export default __webpack_public_path__ + "assets/ico_booking_gold-5c47b905.svg";